'use client';

import { useTranslation } from '@/hooks/useTranslation';
import { paymentApi, type PaymentRecord } from '../_lib/api';
import { Badge, SimpleListPage } from '../_lib/SimpleListPage';

const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  NOT_PAID_YET: { bg: '#fff7e8', text: '#ff7d00' },
  PARTIAL: { bg: '#fff8e6', text: '#d4a017' },
  PAID: { bg: '#e6fff0', text: '#0fc66e' },
  CANCELLED: { bg: '#ffece8', text: '#f53f3f' },
  DRAFT: { bg: '#f0f0f0', text: '#888' },
};

export default function PaymentsPage() {
  const { t } = useTranslation();
  const rm = t.robotManager;
  return (
    <SimpleListPage<PaymentRecord>
      title={rm.lists.payments.title}
      description={rm.lists.payments.description}
      load={async (p) => (await paymentApi.list(p)).items}
      searchPlaceholder={rm.lists.payments.searchPlaceholder}
      columns={[
        { key: 'paymentNo', label: rm.fields.paymentNo, width: '180px' },
        { key: 'direction', label: rm.fields.direction, width: '100px', render: (p) => <Badge text={p.direction === 'INBOUND' ? rm.fields.paymentInbound : rm.fields.paymentOutbound} bg={p.direction === 'INBOUND' ? '#e6fff0' : '#fff7e8'} color={p.direction === 'INBOUND' ? '#0fc66e' : '#ff7d00'} /> },
        { key: 'relatedType', label: rm.fields.relatedType, width: '140px' },
        { key: 'amount', label: rm.fields.amount, width: '140px', render: (p) => `${p.currencyCode} ${Number(p.amount).toLocaleString()}` },
        { key: 'paymentMethod', label: rm.fields.paymentMethod, width: '140px' },
        { key: 'paymentStatus', label: rm.fields.status, width: '120px', render: (p) => {
          if (!p.paymentStatus) return '-';
          const c = STATUS_COLORS[p.paymentStatus] ?? { bg: '#f0f0f0', text: '#888' };
          return <Badge text={p.paymentStatus} bg={c.bg} color={c.text} />;
        } },
        { key: 'paidAt', label: rm.fields.paidAt, render: (p) => p.paidAt ? new Date(p.paidAt).toLocaleDateString() : '-' },
      ]}
    />
  );
}
